import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import api from "../../../api/axiosInterceptor";
import { API_BASE_URL } from "../../../config";
import { SnackBarComponent } from "../../../Components/snackBar/snackBar";

export default function FEClaimsStatusVer2() {
  const [summary, setSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const showSnackbar = (msg, sev = "info") =>
    setSnackbar({ open: true, message: msg, severity: sev });
  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const fetchSummary = async () => {
    setLoading(true);
    try {
      const res = await api.get(
        `/claim-mgmt/verifier2-claim_summary/`
      );
      setSummary(res.data);
    } catch (err) {
      console.error("Error fetching FE claims status ver2 summary", err);
      showSnackbar("Failed to load summary data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  return (
    <Box sx={{ p: 4 }}>
      <Typography
        variant="h4"
        sx={{
          mb: 4,
          fontWeight: "bold",
          textAlign: "center",
          background: "linear-gradient(90deg, #2563EB, #10B981, #F59E0B)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.3)"
        }}
      >
        FE Claims Status Verifier 2 Summary
      </Typography>

      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{ height: "50vh" }}
        >
          <CircularProgress size={60} />
        </Box>
      ) : summary.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: "center" }}>
          <Typography>No data available</Typography>
        </Paper>
      ) : (
        <Card sx={{ borderRadius: 3, boxShadow: 5 }}>
          <CardContent>
            <TableContainer component={Paper}>
              <Table>
                <TableHead sx={{ backgroundColor: "#2563EB" }}>
                  <TableRow>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                      Financial Establishment
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Total Claims
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Verified By Me
                    </TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }} align="center">
                      Verified Today
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {summary.map((row, index) => (
                    <TableRow key={index} hover>
                      <TableCell>{row.fe_name}</TableCell>
                      <TableCell align="center">{row.total_claims}</TableCell>
                      <TableCell align="center">{row.verified_by_me}</TableCell>
                      <TableCell align="center">{row.verified_today}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={closeSnackbar}
      />
    </Box>
  );
}
